export default __webpack_public_path__ + "static/media/bike4.4f07a4ab.jpg";